import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
} from '@mui/material';

const BillingDetails = ({ order }) => {
  const billing = order?.billingAddress || {};
  const shipping = order?.shippingAddress || {};
  const hasBilling = Object.values(billing).some((v) => v);
  const address = hasBilling ? billing : shipping;

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Billing Address</Typography>
        </Box>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="body2">Street: {address.street || '—'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">City: {address.city || '—'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">State: {address.state || '—'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Pincode: {address.pincode || '—'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Country: {address.country || '—'}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BillingDetails;
